/* eslint-disable */
import React from "react";
import moment from "moment";
import AttachmentFile from "../../Images/attachment.png";
import { DisplayMsg } from "../../services/toastService";
import { BASE_FILE_URL, setUrl } from "../../handlers";
import { downloadDocument } from "../../services/DocumentApi";
import { downloadFileFromJsonBlob } from "../../utils/helper";

export default function MessageBox(props) {
  const CurMessage = props.item.commentData;

  const resolutionShow = (event) => {
    const data = {
      event,
      comments: CurMessage.COMMENTS,
      resolution_seqNumb: CurMessage.RESOLUTION_SEQ_NUM,
      comment_seqNumb: CurMessage.SEQ_NUM,
    };
    props.resolutionCallback(data);
  };

  const GetAttachmentPath = async (e, commentSeqNum, ticketNumber) => {
    try {
      e.preventDefault();
      const data = new FormData();
      data.append("commentSeqNum", commentSeqNum);
      data.append("ticketNumber", ticketNumber);
      document.getElementById("loader").style.display = "block";

      const result = await fetch(
        setUrl("TICKETDETAIL", "DOWNLOAD_TICKET_MSG_ATTACHMENTS", true),
        {
          method: "POST",
          body: data,
        },
      );

      const response = await result.json();

      if (!response?.status || !response?.FilesData?.length) {
        DisplayMsg("2", "No attachments found");
        return;
      }

      for (const file of response.FilesData) {
        await DownloadAttachments(file.FILE_PATH, file.FILE_NAME);
      }
    } catch (error) {
      console.error("Unable to process the request:", error);
      DisplayMsg("2", "Unable to Process the Request");
      document.getElementById("loader").style.display = "none";
    } finally {
      document.getElementById("loader").style.display = "none";
    }
  };

  const DownloadAttachments = async (filePath, downloadFileName) => {
    try {
      if (filePath) {
        const extension = downloadFileName.split(".").pop();

        const fullPath =
          `${filePath ?? ""}/${downloadFileName ?? ""}`.toLowerCase();

        document.getElementById("loader").style.display = "block";
        const response = await downloadDocument(fullPath, extension);

        if (response) {
          downloadFileFromJsonBlob(response.data, downloadFileName);
        } else {
          DisplayMsg("2", "Failed to download file");
        }

        document.getElementById("loader").style.display = "none";
      }
    } catch (e) {
      DisplayMsg("2", "File not downloaded");
    }
  };

  return (
    <div className="tab-content">
      <div className="tab-pane active">
        <div className="row">
          <div className="col-md-12 col-sm-12 mb-2">
            <div className="commentsBox">
              <div className="commentHeader">
                <div>
                  <a href="javascript:;">
                    {CurMessage.ENTERED_BY_NAME
                      ? CurMessage.ENTERED_BY_NAME
                      : ""}
                  </a>
                  &nbsp; added a comment -&nbsp;
                  <a href="javascript:;">
                    {moment(CurMessage.ENTERED_DATE).format(
                      "MM/DD/YYYY hh:mm:ss A",
                    )}
                  </a>
                  {CurMessage.isAttachmentExist === "Y" ? (
                    <span
                      onClick={(e) =>
                        GetAttachmentPath(
                          e,
                          CurMessage.SEQ_NUM,
                          CurMessage.PARENT_TICKET,
                        )
                      }
                      title="Download Attachment(s)"
                      role="button"
                    >
                      &nbsp; &nbsp;
                      <img
                        alt="attachment"
                        src={AttachmentFile}
                        className="IconDocuments"
                      />
                      <p className="attachment-count  d-inline pb-3">
                        [{CurMessage.AttachmentCount}]
                      </p>
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                <div className="d-flex">
                  {CurMessage.USER_NOTIFIED === "Y" ? (
                    <div className="mr-5" style={{ fontSize: "12px" }}>
                      [User Notified]
                    </div>
                  ) : (
                    ""
                  )}

                  {!(
                    props.item.resolutionAdded &&
                    props.item.resolutionAdded.length > 0
                  ) ? (
                    <div className="d-flex">
                      {!(
                        props.item.resolutionAdded &&
                        props.item.resolutionAdded.length > 0
                      ) ? (
                        <input
                          className="mx-2"
                          type="checkbox"
                          COMMENT_SEQ_NUM={CurMessage.SEQ_NUM}
                          comments={encodeURIComponent(CurMessage.COMMENTS)}
                          checked={CurMessage.isCheck}
                          onClick={(e) => resolutionShow(e)}
                        />
                      ) : (
                        ""
                      )}
                      Add to Resolution
                    </div>
                  ) : (
                    ""
                  )}

                  {CurMessage.RESOLUTION === "Y" && (
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        className="mx-2"
                        RESOLUTION_SEQ_NUM={CurMessage.RESOLUTION_SEQ_NUM}
                        COMMENT_SEQ_NUM={CurMessage.SEQ_NUM}
                        comments={encodeURIComponent(
                          CurMessage.RESOLUTION_COMMENTS,
                        )}
                        des={encodeURIComponent(
                          CurMessage.RESOLUTION_TICKET_DES,
                        )}
                        checked
                        disabled
                      />
                      <span>Add to Resolution</span>
                    </div>
                  )}
                </div>

                {CurMessage.VIEWABLE_BY === "I" ? (
                  <span>[Visible to internal users]</span>
                ) : (
                  ""
                )}
              </div>
              <div className="commentBody">
                <div
                  style={{ lineHeight: "1.5" }}
                  dangerouslySetInnerHTML={{ __html: CurMessage.COMMENTS }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
